import { z } from "zod";
import { ContractorType } from "../enums/ContractorType";
import { EnrolleeStatus } from "../enums/EnrolleeStatus";
import { LiabilityRatePer } from "../enums/LiabilityRatePer";
import { LiabilityRateType } from "../enums/LiabilityRateType";
import { dateSchema } from "../utils/DateSchema";
import { idSchema } from "../utils/IdSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";
import { AddressSchema } from "./Address";

export const EnrolleeSchema = z.object({
  id: idSchema(),
  name: requiredStringSchema().max(250),
  emailAddress: z.string().max(250).optional(),
  address: AddressSchema.optional(),
  typeOfWork: nameSchema().optional(),
  status: EnrolleeStatus,
  source: z.object({
    id: z.string().uuid(),
    name: requiredStringSchema().max(250),
  }),
  project: z.object({
    id: z.string().uuid(),
    name: requiredStringSchema().max(250),
  }),
  contractNumber: z.string().max(50),
  awardingContractor: nameSchema().optional(),
  contractorType: ContractorType.optional(),
  awardDate: dateSchema().optional(),
  expirationDate: dateSchema().optional(),
  estimatedContractValue: z.number().optional(),
  estimatedSitePayroll: z.number().optional(),
  fein: z.string().max(50).optional(),
  liabilityRate: z.number().optional(),
  liabilityRateType: LiabilityRateType.optional(),
  liabilityRatePer: LiabilityRatePer.optional(),
  policyDeductible: z.number().optional(),
  selfInsuredRetention: z.number().optional(),
  bidDeductPercentage: z.number().min(0).max(100).optional(),
  notes: z.string().max(2000).optional(),
  updatedDate: dateSchema().optional(),
});

export type Enrollee = z.infer<typeof EnrolleeSchema>;
